import React from 'react';
import styles from './course-fees-and-pricing.module.scss';
import Markdown from 'markdown-to-jsx';
import { FeesAndPricingData } from './course-fees-and-pricing-calculation';

export type Props = {
  feesAndPricingData: FeesAndPricingData;
};
export default function CourseFeesAndPricing({ feesAndPricingData }: Props) {
  return (
    <div className={styles['important-dates']}>
      <div className='row mb-3'>
        <div className='col'>
          <h5>Estimated cost of attendance</h5>
        </div>
      </div>
      <div className='fees-container'>
        {feesAndPricingData.feesList.map((row) => (
          <div
            key={row.title.toLowerCase().replace(' ', '-')}
            className={`row ${styles['fee-row']}`}
          >
            <div className='col-8 col-md'>
              <p>{row.title}</p>
            </div>
            <div className='col-4 col-md'>
              <p className={`${styles['bold-value']}`}>{row.value}</p>
            </div>
          </div>
        ))}
      </div>
      {feesAndPricingData.feesTotal && (
        <div className='row mb-3'>
          <div className='col-8 col-md'>
            <p className={`${styles['bold-value']}`}>{feesAndPricingData.feesTotal.title}</p>
          </div>
          <div className='col-4 col-md'>
            <p className={`${styles['bold-value']} total-value`}>
              {feesAndPricingData.feesTotal.value}
            </p>
          </div>
        </div>
      )}
      {feesAndPricingData.feesNote ? (
        <Markdown>{feesAndPricingData.feesNote}</Markdown>
      ) : (
        <p>Detailed pricing breakdown coming soon</p>
      )}
    </div>
  );
}
